import { NgModule } from '@angular/core';
import { RadioComponent } from './radio.component';

@NgModule({
  declarations: [
    RadioComponent,
  ],
  exports: [
    RadioComponent,
  ],
})
export class RadioModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/RadioComponent/radio.module.ts